import type { Subscription } from '../../types';
import { isTrial as isLegacySubscriptionTrial } from '../legacySubscription';
import { isModernSubscriptionTrial } from '../modernSubscription/isTrial';

import { isModernSubscription } from './isModernSubscription';

/**
 * Determines if a user is in trial.
 *
 * For modern subscriptions, returns true if the subscription state is one of:
 *   - SubscriptionStates.ACTIVE_TRIAL
 *   - SubscriptionStates.GRACE_PERIOD_TRIAL
 *   - SubscriptionStates.LAPSED_TRIAL
 * (Does NOT include ACTIVE_TRIAL_WITH_SUBSCRIPTION or any other state.)
 *
 * For legacy subscriptions, returns the value of the `isTrial` property on the subscription object (if present), or false if not.
 *
 * @param subscription The user's subscription object
 * @returns boolean indicating if the user is in trial
 */
export function isTrial(subscription: Subscription): boolean {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionTrial(subscription);
  }
  return isLegacySubscriptionTrial(subscription);
}
